module.exports = __webpack_public_path__ + "static/img/a097.45fdba9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a097.jpg
// module id = oFDH
// module chunks = 0